import styled from 'styled-components';
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width:100%;
  height:100vh;
  padding: 2rem;
  gap: .5rem;
  background: linear-gradient(0deg, #337CCF 0%, #2353B9 53%, #1C3FAF 100%);
`;

export const Header = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  > div {
    width: 300px;
    position: relative;
    display: flex;
    align-items: center;
    > input {
      width: 100%;
      height: 3rem;
      padding-left: 2.5rem;
      border-radius: 0.3rem;
      border: none;
      outline: none;
      background: ${({ theme }) => theme.colors.__white[100]};
      color: #495057;
    }
    > svg {
      position: absolute;
      left: 0.5rem;
      font-size: 1.5rem;
      color: ${({ theme }) => theme.colors.__gray[500]};
    }
  } 
  > h1 {
    color: ${({ theme }) => theme.colors.__white};
  }
`;
export const Content = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  padding-top: 4rem;
  padding-bottom: 2rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  overflow-x: hidden;
  overflow-y: scroll;
  &::-webkit-scrollbar{
    width: 5px;
  }
  &::-webkit-scrollbar-thumb{
    background-color: transparent;
  }
`;